<template>
  <EditBox :name="name" :styleList="styleList" :currentStyle.sync="localStyle" :tip="'页面基础设置（轮播图左右边距固定为0）'">
    <ItemSetting label="背景颜色">
      <el-color-picker v-model="backgroundColor" show-alpha></el-color-picker>
    </ItemSetting>
    <ItemSetting label="背景图片">
      <div class="image-setting">
        <UploadImage ref="imageUploader" @upload-success="updateImage" position="left" />
        <el-button size="small" @click="clearImage">清空</el-button>
      </div>
    </ItemSetting>
    <ItemSetting label="左右边距">
      <el-input type="number" placeholder="请输入左右边距" v-model.number="paddingX"></el-input>
    </ItemSetting>
  </EditBox>
</template>

<script>
import EditBox from "./box/EditBox";
import ItemSetting from "./setting/ItemSetting";
import UploadImage from "@/components/Upload/UploadImage";
import editMixin from './mixins/editMixin';

export default {
  name: 'PageEdit',
  mixins: [editMixin],
  components: {
    EditBox,
    ItemSetting,
    UploadImage
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    styleList: {
      type: Array,
      default: () => []
    },
    currentStyle: {
      type: String,
      default: ''
    },
    value: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    updateImage(url) {
      this.updateValue({ backgroundImage: url })
    },
    clearImage() {
      this.updateValue({ backgroundImage: '' })
    }
  },
  computed: {
    backgroundColor: {
      get() {
        return this.value.backgroundColor
      },
      set(val) {
        this.updateValue({ backgroundColor: val })
      }
    },
    paddingX: {
      get() {
        return this.value.paddingX
      },
      set(val) {
        if (!val) {
          val = 0
        }
        if (val < 0) {
          this.$message.error('左右边距必须大于等于0')
          return
        }
        if (val > 50) {
          this.$message.error('左右边距必须小于等于50')
          return
        }
        this.updateValue({ paddingX: val })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.image-setting {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
